import { Box, IconButton, SvgIcon, withStyles } from '@material-ui/core';
import MicRecorder from 'mic-recorder-to-mp3';
import { Component } from 'react';
import setupUserMedia from './SetupUserMedia';
import {
  CircleIcon,
  DeleteIcon,
  LeftArrowIcon,
  MicIcon,
  PlayArrowIcon,
} from './SvgIcons';
import Timer from './Timer';

export const AUDIO_RECORDING_MAX_WIDTH = 240;

const styles = theme => ({
  iconButton: {
    backgroundColor: theme.palette.primary.main,
    height: '40px',
    width: '40px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '& svg': {
      color: theme.palette.primary.contrastText,
    },
    '&:disabled': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.5,
    },
  },
  deleteIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFFFF',
    backgroundColor: theme.b2chatred[100],
    borderRadius: 9999,
    width: '36px',
    height: '36px',
    cursor: 'pointer',
  },
  circleIcon: {
    color: theme.b2chatred[100],
    padding: 0,
    marginTop: '2px',
  },
});

class AudioRecording extends Component {
  constructor(props) {
    super(props);
    setupUserMedia();
    this.mp3Recorder = new MicRecorder({ bitRate: 128 });
    this.state = {
      isRecordingState: false,
    };
  }

  startRecording = () => {
    const { isRecordingState } = this.state;
    const { setIsRecording } = this.props;
    if (!isRecordingState) {
      this.mp3Recorder
        .start()
        .then(() => {
          this.setState({ isRecordingState: true });
          setIsRecording(true);
        })
        // eslint-disable-next-line no-console
        .catch(error => console.error(error));
    }
  };

  discardRecording = () => {
    const { setIsRecording } = this.props;
    this.mp3Recorder
      .stop()
      .getMp3()
      .then(() => {
        this.setState({ isRecordingState: false });
        setIsRecording(false);
      })
      // eslint-disable-next-line no-console
      .catch(error => console.log(error));
  };

  getRecording = () => {
    this.mp3Recorder
      .stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const { onRecordingStopped, setIsRecording } = this.props;
        this.setState({ isRecordingState: false });
        setIsRecording(false);
        if (onRecordingStopped) {
          onRecordingStopped(buffer, blob);
        }
      })
      // eslint-disable-next-line no-console
      .catch(error => console.log(error));
  };

  componentDidUpdate(prevProps) {
    const { isRecording } = this.props;
    if (prevProps.isRecording !== isRecording && isRecording) {
      this.startRecording();
    }
  }

  render() {
    const { isRecordingState } = this.state;
    const { classes, disabled, cancelLabel } = this.props;
    return (
      <div>
        {isRecordingState ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              border: '5px',
              width: `${AUDIO_RECORDING_MAX_WIDTH}px'`,
              gap: '8px',
            }}
          >
            <Box className={classes.deleteIcon} onClick={this.discardRecording}>
              {DeleteIcon}
            </Box>

            <div
              style={{
                fill: 'red',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                minWidth: '8px',
                gap: '8px',
              }}
            >
              <Box display="flex" style={{ color: '#707388' }}>
                <Box>{LeftArrowIcon}</Box> <Box mt="1.5px">{cancelLabel}</Box>
              </Box>
              <IconButton className={classes.circleIcon}>
                {CircleIcon}
              </IconButton>
              <Timer />
            </div>
            <IconButton
              disabled={!isRecordingState}
              onClick={this.getRecording}
              className={classes.iconButton}
            >
              <SvgIcon color="inherit">{PlayArrowIcon}</SvgIcon>
            </IconButton>
          </div>
        ) : (
          <IconButton
            onClick={this.startRecording}
            className={classes.iconButton}
            disabled={disabled}
          >
            <SvgIcon color="inherit">{MicIcon}</SvgIcon>
          </IconButton>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(AudioRecording);
